<div [class]="'errors ' + customCssClasses " *ngIf="show">
    <p class="text-[var(--red)] mt-2 text-sm">{{ errorMsg }}</p>
</div>